import { render, staticRenderFns } from "./Faixas.vue?vue&type=template&id=22080ceb"
import script from "./Faixas.vue?vue&type=script&lang=js"
export * from "./Faixas.vue?vue&type=script&lang=js"
import style0 from "./Faixas.vue?vue&type=style&index=0&id=22080ceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports